export const pakistanKarakoramValleysProgram = {
  programKey: 'pakistan-dolinami-pod-lodowce-karakorum',

  /* Podstawowe informacje wspólne dla sticky paska i katalogu. */
  title: 'Pakistan - Dolinami pod lodowce Karakorum',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Pakistan:',
  stickySubtitle: 'Dolinami pod lodowce Karakorum',

  pageUrl:
    'https://coolturystki.pl/wycieczki/pakistan-dolinami-pod-lodowce-karakorum',

  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-pakistan-dolina-hunza-mvpflq86.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-pakistan-dolina-hunza-mvpflq86.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Pakistan'],
    continent: 'Azja',
    categories: [],
    travelStyles: ['Wyjazd objazdowy', 'Aktywnie', 'Egzotyka'],
    catalogPublishedAt: '2026-10-27',
  },

  /* Termin o ID 37: 1 - 11 maja 2027. */
  tripIds: [37],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '37': {
      pilotId: 'dorota',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy z Warszawy',
          description:
            'Wspólna podróż odbywa się z Lotniska Chopina w Warszawie (WAW) do Islamabadu (ISB) i z powrotem, z przesiadką w Stambule.',
        },
        hotel: {
          title: 'Hotele i resorty 2★–4★ na trasie',
          description:
            '9 noclegów w pokojach 2-osobowych w Islamabadzie, Skardu, Hunzie i Besham. W cenie są śniadania, obiady, kolacje oraz nielimitowana herbata i woda mineralna.',
        },
      },
    },
  },
}
